const storageHelper = require('./storageHelper');

var authenticate = {
  isAuthenticated: () => {
    const loggedUser = storageHelper.getFromStorage('loggedUser');
    const authenticated = loggedUser ? true : false;
    return authenticated;
  },
  isAdminLogged: () => {
    const loggedUser = storageHelper.getFromStorage('loggedUser');
    const isAdmin = loggedUser.user.type === 2 || loggedUser.user.type === 3 ? true : false;
    return isAdmin;
  }
};

module.exports = authenticate;


// WEBPACK FOOTER //
// ./src/libs/helpers/authenticationHelper.js